export const responsiveFontSize = (min: number, max: number): string =>
  `calc(${min}px + (${max} - ${min}) * ((100vw - 300px) / (1920 - 355)))`;
